import { authorizedRequest, logout } from './account';
import { responseError } from './errors';

require('dotenv').config();

const ENV = process.env;

export const REQUEST_CONTINENTS = 'REQUEST_CONTINENTS';
export const RECEIVE_CONTINENTS = 'RECEIVE_CONTINENTS';
export const RECEIVE_CONTINENT = 'RECEIVE_CONTINENT';

export const requestContinents = () => ({
  type: REQUEST_CONTINENTS,
});

export const receivedContinents = json => ({
  type: RECEIVE_CONTINENTS,
  json,
});

export const receivedContinent = json => ({
  type: RECEIVE_CONTINENT,
  json,
});

export const createContinent = params => (
  (dispatch) => {
    dispatch(requestContinents());
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/continents`, { method: 'POST', headers, body: JSON.stringify(params) })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(responseError('Unauthorized'));
        }
        return json;
      });
  }
);

export const deleteContinent = id => (
  (dispatch) => {
    dispatch(requestContinents());
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/continents/${id}`, { method: 'DELETE', headers: {} })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(responseError('Unauthorized'));
        }
        return json;
      });
  }
);

export const fetchContinents = sort => (
  (dispatch) => {
    dispatch(requestContinents());
    let url = `${ENV.REACT_APP_API_SERVER}/continents`;
    if (sort) url += `?order=${JSON.stringify(sort)}`;
    return authorizedRequest(url, { method: 'GET' })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
          dispatch(receivedContinents([]));
        } else if (json.status === 401) {
          dispatch(logout());
          dispatch(receivedContinents([]));
        } else {
          dispatch(receivedContinents({ data: json } || []));
        }
        return json;
      });
  }
);

export const fetchContinent = id => (
  (dispatch) => {
    dispatch(requestContinents());
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/continents/${id}`, { method: 'GET' })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(logout());
        } else {
          dispatch(receivedContinent(json));
        }
        return json;
      });
  }
);

export const saveContinent = (id, params) => (
  (dispatch) => {
    dispatch(requestContinents());
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/continents/${id}`, { method: 'POST', headers, body: JSON.stringify(params) })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(responseError('Unauthorized'));
        }
        return json;
      });
  }
);
